import { tns } from 'tiny-slider'
import { registerComponent } from '../components-front';

registerComponent('icon-carousel', _ => {
    document.querySelectorAll('.icon-carousel-wrapper').forEach(carouselWrapper => {
        const carousel = carouselWrapper.querySelector('.icon-carousel')
        const cols = carousel.dataset.cols || 2

        /** @var {HTMLDivElement} prev */
        const prev = carouselWrapper.querySelector('.prev')
        /** @var {HTMLDivElement} next */
        const next = carouselWrapper.querySelector('.next')

        const slider = tns({
            container: carousel,
            items: Math.max(2, Math.floor(cols / 2)),
            // items: 3,
            slideBy: 1,
            // gutter: 50,
            arrowKeys: true,
            prevButton: prev,
            nextButton: next,
            lazyload: true,
            nav: true,
            navPosition: 'bottom',
            responsive: {
                300: {
                    items: 1,
                },
                992: {
                    items: cols,
                    nav: false,
                },
            },
        })
    })
})
